import { Flex } from 'antd';
import { useIsAuthenticated } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import useLogout from '@Hooks/useLogout';

import backgroundImage from '@Images/login-page-background.jpg';
import { ErrorPageTypes } from '@Enum/ErrorPageTypes.enum';

import styles from './error-page.module.css';
import { getPageSpecificData } from './utils';

const backgroundStyle = `linear-gradient(rgba(227, 237, 247, 1), rgba(227, 237, 247, 0.4), rgba(227, 237, 247, 0)), url(${backgroundImage})`;

interface ErrorPageProps {
  type: ErrorPageTypes;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ type }) => {
  const navigate = useNavigate();
  const { logout } = useLogout();
  const isAuthenticated = useIsAuthenticated();

  if (type === ErrorPageTypes.FORBIDDEN && !isAuthenticated) {
    navigate('/login');
  }

  const { image, title, description, button } = getPageSpecificData(
    type,
    navigate,
    logout
  );

  return (
    <Flex
      vertical
      className={styles.wrapper}
      style={{
        backgroundImage: backgroundStyle,
      }}
    >
      <Flex className={styles.innerWrapper}>
        <Flex vertical className={styles.contentWrapper}>
          {image}
          {title}
          {description}
          {button}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default ErrorPage;
